
import template from './_recharge-free.pug'

// @vue/component
export default Vue.extend({
  template: template(),
  props: {
    amount: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      errors: {}
    }
  },computed: { },
  watch: { }
})